(function () {
  function formatMoney(cents, format) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format || window.theme?.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function isFiveStarReview(article) {
    if (!article) return false;
    var a11y = article.querySelector('.okeReviews-review-starRating .okeReviews-a11yText');
    if (a11y && /rated\s+5\s+out\s+of\s+5/i.test(a11y.textContent)) return true;
    var fg = article.querySelector(
      '.okeReviews-review-starRating .okeReviews-starRating-indicator-layer--foreground'
    );
    if (!fg) return false;
    var width = parseFloat(String(fg.style.width || '').replace('%', ''));
    return !isNaN(width) && width >= 99;
  }

  function findFirstFiveStarReview(sourceRoot) {
    if (!sourceRoot) return null;
    var articles = sourceRoot.querySelectorAll('.okeReviews-reviews-review .okeReviews-review');
    for (var i = 0; i < articles.length; i++) {
      if (isFiveStarReview(articles[i])) return articles[i];
    }
    return null;
  }

  function extractReviewText(article) {
    var body = article.querySelector('.okeReviews-review-main-content-body');
    if (!body) return '';
    return (body.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function extractReviewerName(article) {
    var nameEl = article.querySelector('.okeReviews-review-reviewer-profile-name');
    if (nameEl && nameEl.textContent.trim()) return nameEl.textContent.trim();
    return article.getAttribute('data-oke-reviews-reviewer-name') || '';
  }

  function extractAvatar(article) {
    var img = article.querySelector('.okeReviews-avatar-image');
    if (img) {
      var url =
        img.getAttribute('data-oke-reviews-lazy-image-url') ||
        img.getAttribute('src') ||
        '';
      if (url && url.indexOf('data:image') !== 0) return { type: 'image', value: url };
    }
    var initialsEl = article.querySelector('.okeReviews-avatar-placeholder');
    if (initialsEl && initialsEl.textContent.trim()) {
      return { type: 'initials', value: initialsEl.textContent.trim() };
    }
    return null;
  }

  function populateTestimonialCard(card, review, options) {
    var quote = extractReviewText(review);
    if (!quote) return false;

    var author = extractReviewerName(review);
    var avatar = extractAvatar(review);
    var showStars = options.showStars;
    var verifiedLabel = options.verifiedLabel;
    var isVerified = !!review.querySelector(
      '.okeReviews-review-reviewer-profile-status--verified'
    );

    var quoteEl = card.querySelector('[data-ppm-testimonial-quote]');
    var nameEl = card.querySelector('[data-ppm-testimonial-name]');
    var verifiedEl = card.querySelector('[data-ppm-testimonial-verified]');
    var starsEl = card.querySelector('[data-ppm-testimonial-stars]');
    var imgEl = card.querySelector('[data-ppm-testimonial-avatar-img]');
    var initialsEl = card.querySelector('[data-ppm-testimonial-avatar-initials]');

    if (quoteEl) quoteEl.textContent = '"' + quote + '"';
    if (nameEl) nameEl.textContent = author;

    if (imgEl) imgEl.hidden = true;
    if (initialsEl) initialsEl.hidden = true;

    if (avatar && avatar.type === 'image' && imgEl) {
      imgEl.src = avatar.value;
      imgEl.alt = author || 'Reviewer';
      imgEl.hidden = false;
    } else if (avatar && avatar.type === 'initials' && initialsEl) {
      initialsEl.textContent = avatar.value;
      initialsEl.hidden = false;
    }

    if (verifiedEl) {
      verifiedEl.textContent = isVerified ? verifiedLabel : '';
      verifiedEl.hidden = !isVerified;
    }

    if (starsEl) {
      starsEl.hidden = !showStars;
      if (showStars) starsEl.textContent = '★★★★★';
    }

    return true;
  }

  function initTestimonial(root) {
    if (root.dataset.ppmTestimonialInit === 'true') return;

    var wrap = root.querySelector('[data-ppm-testimonial]');
    var source = root.querySelector('[data-ppm-okendo-source]');
    var card = root.querySelector('[data-ppm-testimonial-card]');
    if (!wrap || !card) return;

    if (!source) {
      root.dataset.ppmTestimonialInit = 'true';
      return;
    }

    var review = findFirstFiveStarReview(source);
    if (!review) {
      wrap.classList.add('is-ppm-testimonial-empty');
      return;
    }

    var options = {
      showStars: wrap.dataset.showStars !== 'false',
      verifiedLabel: wrap.dataset.verifiedLabel || 'Verified Customer',
    };

    if (!populateTestimonialCard(card, review, options)) {
      wrap.classList.add('is-ppm-testimonial-empty');
      return;
    }

    card.hidden = false;
    wrap.classList.remove('is-ppm-testimonial-empty');
    root.dataset.ppmTestimonialInit = 'true';
  }

  var DESCRIPTION_WORD_LIMIT = 30;
  var PPM_EXPAND_DURATION_MS = 350;

  function ppmPrefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function ppmAnimateHeight(element, targetHeightPx, onComplete) {
    var done = onComplete || function () {};
    var isAuto = targetHeightPx === 'auto';
    var target = isAuto ? 'auto' : targetHeightPx + 'px';

    if (ppmPrefersReducedMotion()) {
      element.style.transition = '';
      element.style.overflow = isAuto ? '' : 'hidden';
      element.style.height = target;
      done();
      return;
    }

    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      clearTimeout(fallbackId);
      element.removeEventListener('transitionend', onEnd);
      done();
    }

    function onEnd(event) {
      if (event.propertyName !== 'height') return;
      finish();
    }

    element.style.overflow = 'hidden';
    element.style.transition = 'height ' + PPM_EXPAND_DURATION_MS + 'ms ease';
    element.addEventListener('transitionend', onEnd);
    var fallbackId = setTimeout(finish, PPM_EXPAND_DURATION_MS + 80);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        element.style.height = target;
      });
    });
  }

  function ppmMeasureContentHeight(content) {
    var previousHeight = content.style.height;
    content.style.height = 'auto';
    var height = content.scrollHeight;
    content.style.height = previousHeight;
    return height;
  }

  function initAccordions(root) {
    root.querySelectorAll('.ppm-accordion').forEach(function (details) {
      if (details.dataset.ppmAccordionInit === 'true') return;

      var summary = details.querySelector('.ppm-accordion__summary');
      var content = details.querySelector('.ppm-accordion__content');
      if (!summary || !content) return;

      details.dataset.ppmAccordionInit = 'true';

      if (details.open) {
        details.classList.add('is-ppm-accordion-open');
        content.style.height = 'auto';
      } else {
        content.style.height = '0px';
      }

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (details.dataset.ppmAccordionAnimating === 'true') return;

        var isOpen =
          details.classList.contains('is-ppm-accordion-open') || details.open;

        if (isOpen) {
          details.dataset.ppmAccordionAnimating = 'true';
          content.style.overflow = 'hidden';
          content.style.height = content.scrollHeight + 'px';
          void content.offsetHeight;
          ppmAnimateHeight(content, 0, function () {
            details.open = false;
            details.classList.remove('is-ppm-accordion-open');
            content.style.height = '0px';
            content.style.overflow = '';
            content.style.transition = '';
            details.dataset.ppmAccordionAnimating = 'false';
          });
        } else {
          details.dataset.ppmAccordionAnimating = 'true';
          details.open = true;
          details.classList.add('is-ppm-accordion-open');
          var endHeight = ppmMeasureContentHeight(content);
          content.style.height = '0px';
          void content.offsetHeight;
          ppmAnimateHeight(content, endHeight, function () {
            content.style.height = 'auto';
            content.style.overflow = '';
            content.style.transition = '';
            details.dataset.ppmAccordionAnimating = 'false';
          });
        }
      });
    });
  }

  function countWords(text) {
    return (text || '').trim().split(/\s+/).filter(Boolean).length;
  }

  /** Normalize truncated HTML (closes tags the browser would infer when parsing). */
  function ppmCloseHtmlTags(html) {
    if (!html) return '';
    var doc = document.createElement('div');
    doc.innerHTML = html;
    return doc.innerHTML;
  }

  function ppmMeasureHtmlHeight(shell, contentEl, html) {
    var width = contentEl.getBoundingClientRect().width;
    if (!width) width = shell.getBoundingClientRect().width;
    var probe = document.createElement('div');
    probe.className = contentEl.className;
    probe.style.cssText =
      'position:absolute;left:0;top:0;visibility:hidden;pointer-events:none;width:' +
      width +
      'px;box-sizing:border-box';
    probe.innerHTML = html;
    shell.appendChild(probe);
    var height = probe.offsetHeight;
    shell.removeChild(probe);
    return height;
  }

  function initDescription(root) {
    var wrap = root.querySelector('[data-ppm-description]');
    if (!wrap || wrap.dataset.ppmDescriptionInit === 'true') return;

    var shell = wrap.querySelector('[data-ppm-description-shell]');
    var content = wrap.querySelector('[data-ppm-description-content]');
    var shortTemplate = wrap.querySelector('[data-ppm-description-short]');
    var fullTemplate = wrap.querySelector('[data-ppm-description-full]');
    var toggle = wrap.querySelector('[data-ppm-description-toggle]');
    if (!shell || !content || !fullTemplate || !toggle) return;

    var fullHtml = fullTemplate.innerHTML.trim();
    if (!fullHtml) return;

    var shortHtml = ppmCloseHtmlTags(
      shortTemplate ? shortTemplate.innerHTML.trim() : content.innerHTML.trim()
    );
    content.innerHTML = shortHtml;

    var temp = document.createElement('div');
    temp.innerHTML = fullHtml;
    if (countWords(temp.textContent) <= DESCRIPTION_WORD_LIMIT) return;

    wrap.dataset.ppmDescriptionInit = 'true';
    var expanded = false;
    var animating = false;

    function finishShellHeight() {
      shell.style.height = 'auto';
      shell.style.overflow = '';
      shell.style.transition = '';
      animating = false;
    }

    function updateToggle(isExpanded) {
      toggle.textContent = isExpanded ? 'Read Less' : 'Read More';
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }

    function setExpandedInstant(isExpanded) {
      expanded = isExpanded;
      content.innerHTML = isExpanded ? fullHtml : shortHtml;
      shell.style.height = '';
      shell.style.overflow = '';
      shell.style.transition = '';
      updateToggle(isExpanded);
    }

    function expandAnimated() {
      animating = true;
      var startHeight = shell.scrollHeight;
      shell.style.height = startHeight + 'px';
      shell.style.overflow = 'hidden';
      content.innerHTML = fullHtml;
      void shell.offsetHeight;
      var endHeight = shell.scrollHeight;
      ppmAnimateHeight(shell, endHeight, function () {
        expanded = true;
        finishShellHeight();
        updateToggle(true);
      });
    }

    function collapseAnimated() {
      animating = true;
      var startHeight = shell.scrollHeight;
      shell.style.height = startHeight + 'px';
      shell.style.overflow = 'hidden';
      var endHeight = ppmMeasureHtmlHeight(shell, content, shortHtml);
      ppmAnimateHeight(shell, endHeight, function () {
        content.innerHTML = shortHtml;
        expanded = false;
        finishShellHeight();
        updateToggle(false);
      });
    }

    toggle.hidden = false;
    setExpandedInstant(false);

    toggle.addEventListener('click', function () {
      if (animating) return;
      if (expanded) {
        if (ppmPrefersReducedMotion()) setExpandedInstant(false);
        else collapseAnimated();
      } else {
        if (ppmPrefersReducedMotion()) setExpandedInstant(true);
        else expandAnimated();
      }
    });
  }

  function destroyGallerySwipers(root) {
    if (root._ppmHeroSwiper) {
      root._ppmHeroSwiper.destroy(true, true);
      root._ppmHeroSwiper = null;
    }
    if (root._ppmThumbsSwiper) {
      root._ppmThumbsSwiper.destroy(true, true);
      root._ppmThumbsSwiper = null;
    }
  }

  function syncThumbAria(root, activeIndex) {
    root.querySelectorAll('[data-ppm-thumb]').forEach(function (btn) {
      var isActive = btn.dataset.ppmThumb === String(activeIndex);
      btn.classList.toggle('ppm__thumb--active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function goToVariantMedia(root, mediaIndex) {
    if (mediaIndex === '' || mediaIndex == null) return;

    var index = parseInt(mediaIndex, 10);
    if (isNaN(index) || index < 0) return;

    var hero = root._ppmHeroSwiper;
    if (!hero || !hero.slides || index >= hero.slides.length) return;

    hero.slideTo(index);
    syncThumbAria(root, index);

    var thumbs = root._ppmThumbsSwiper;
    if (thumbs && thumbs.slides && index < thumbs.slides.length) {
      thumbs.slideTo(index);
    }
  }

  function initGallery(root) {
    if (typeof Swiper === 'undefined') return;

    var heroEl = root.querySelector('[data-ppm-hero-swiper]');
    if (!heroEl) return;

    destroyGallerySwipers(root);

    var thumbsEl = root.querySelector('[data-ppm-thumbs-swiper]');
    var prevBtn = root.querySelector('[data-ppm-hero-prev]');
    var nextBtn = root.querySelector('[data-ppm-hero-next]');
    var slideCount = heroEl.querySelectorAll('.swiper-slide').length;
    var thumbsSwiper = null;
    var initialSlide = parseInt(root.dataset.ppmInitialSlide || '0', 10);
    if (isNaN(initialSlide) || initialSlide < 0 || initialSlide >= slideCount) {
      initialSlide = 0;
    }

    if (thumbsEl && thumbsEl.querySelectorAll('.swiper-slide').length > 0) {
      thumbsSwiper = new Swiper(thumbsEl, {
        spaceBetween: 6,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        grabCursor: true,
        initialSlide: initialSlide,
        breakpoints: {
          990: {
            spaceBetween: 8,
          },
        },
      });
      root._ppmThumbsSwiper = thumbsSwiper;
    }

    var heroOptions = {
      spaceBetween: 0,
      slidesPerView: 1,
      watchOverflow: true,
      grabCursor: slideCount > 1,
      initialSlide: initialSlide,
    };

    if (slideCount > 1 && prevBtn && nextBtn) {
      heroOptions.navigation = {
        nextEl: nextBtn,
        prevEl: prevBtn,
      };
    }

    if (thumbsSwiper) {
      heroOptions.thumbs = {
        swiper: thumbsSwiper,
      };
    }

    var heroSwiper = new Swiper(heroEl, heroOptions);
    root._ppmHeroSwiper = heroSwiper;

    heroSwiper.on('slideChange', function () {
      syncThumbAria(root, heroSwiper.activeIndex);
    });

    syncThumbAria(root, heroSwiper.activeIndex);
  }

  function updateVariantUrl(root, variantId) {
    if (!variantId || !window.history || !window.history.replaceState) return;
    var baseUrl = root.dataset.url || window.location.pathname;
    var url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.pathname + url.search);
  }

  function findVariantOptionById(root, variantId) {
    if (!variantId) return null;
    var inputs = root.querySelectorAll('[data-ppm-variant-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === String(variantId)) {
        return inputs[i].closest('[data-ppm-variant-block]');
      }
    }
    return null;
  }

  function getUrlVariantId() {
    try {
      return new URLSearchParams(window.location.search).get('variant');
    } catch (e) {
      return null;
    }
  }

  function initSizePackVariants(root, helpers) {
    var sizeBlocks = root.querySelectorAll('[data-ppm-size-block]');
    var packGroups = root.querySelectorAll('[data-ppm-pack-group]');
    var selectVariantBlock = helpers.selectVariantBlock;
    var findVariantOptionById = helpers.findVariantOptionById;
    var getUrlVariantId = helpers.getUrlVariantId;

    function getActivePackGroup() {
      for (var i = 0; i < packGroups.length; i++) {
        if (!packGroups[i].hidden) return packGroups[i];
      }
      return null;
    }

    function setSizeSelected(sizeValue) {
      sizeBlocks.forEach(function (block) {
        var isMatch = block.dataset.sizeValue === sizeValue;
        block.classList.toggle('ppm-variant__option--selected', isMatch);
        var input = block.querySelector('[data-ppm-size-input]');
        if (input) input.checked = isMatch;
      });
    }

    function showPackGroup(sizeValue) {
      packGroups.forEach(function (group) {
        group.hidden = group.dataset.sizeValue !== sizeValue;
      });
    }

    function pickPackInGroup(group, preferredPackValue) {
      if (!group) return null;
      var blocks = group.querySelectorAll('[data-ppm-variant-block]');
      var preferred = null;
      var first = blocks[0] || null;

      for (var i = 0; i < blocks.length; i++) {
        var block = blocks[i];
        if (preferredPackValue && block.dataset.packValue === preferredPackValue) {
          preferred = block;
          break;
        }
      }

      return preferred || first;
    }

    function getCurrentPackValue() {
      var group = getActivePackGroup();
      if (!group) return '';
      var selected = group.querySelector('.ppm-variant__option--selected');
      if (selected && selected.dataset.packValue) return selected.dataset.packValue;
      var checked = group.querySelector('[data-ppm-variant-input]:checked');
      if (checked) {
        var block = checked.closest('[data-ppm-variant-block]');
        return (block && block.dataset.packValue) || '';
      }
      return '';
    }

    function selectSize(sizeValue, options) {
      var opts = options || {};
      var preferredPack =
        opts.preferredPackValue != null ? opts.preferredPackValue : getCurrentPackValue();

      setSizeSelected(sizeValue);
      showPackGroup(sizeValue);

      var group = null;
      for (var i = 0; i < packGroups.length; i++) {
        if (packGroups[i].dataset.sizeValue === sizeValue) {
          group = packGroups[i];
          break;
        }
      }

      var packBlock =
        (opts.variantId && findVariantOptionById(root, opts.variantId)) ||
        pickPackInGroup(group, preferredPack);

      if (packBlock) {
        selectVariantBlock(packBlock, {
          updateUrl: opts.updateUrl,
          scopeRoot: group,
        });
      }
    }

    sizeBlocks.forEach(function (block) {
      block.addEventListener('click', function (event) {
        event.preventDefault();
        selectSize(block.dataset.sizeValue, { updateUrl: true });
      });
    });

    packGroups.forEach(function (group) {
      group.querySelectorAll('[data-ppm-variant-block]').forEach(function (option) {
        option.addEventListener('click', function () {
          selectVariantBlock(option, { updateUrl: true, scopeRoot: group });
        });
      });
    });

    var urlVariantId = getUrlVariantId();
    var urlOption = findVariantOptionById(root, urlVariantId);
    if (urlOption) {
      selectSize(urlOption.dataset.sizeValue, {
        preferredPackValue: urlOption.dataset.packValue,
        variantId: urlVariantId,
        updateUrl: true,
      });
      return;
    }

    var selectedSize =
      root.querySelector('[data-ppm-size-block].ppm-variant__option--selected') || sizeBlocks[0];
    if (selectedSize) {
      selectSize(selectedSize.dataset.sizeValue, {
        preferredPackValue: getCurrentPackValue(),
        updateUrl: false,
      });
    }
  }

  function initSection(root) {
    if (!root || root.dataset.ppmInit === 'true') return;
    root.dataset.ppmInit = 'true';

    initDescription(root);
    initAccordions(root);
    initGallery(root);

    var variantInput = root.querySelector('[data-ppm-variant-id]');
    var atcPrice = root.querySelector('[data-ppm-atc-price]');
    var moneyFormat = root.dataset.moneyFormat;

    function selectVariantBlock(option, options) {
      var opts = options || {};
      root.querySelectorAll('[data-ppm-variant-block]').forEach(function (el) {
        el.classList.remove('ppm-variant__option--selected');
        var input = el.querySelector('[data-ppm-variant-input]');
        if (input) input.checked = false;
      });
      option.classList.add('ppm-variant__option--selected');
      var radio = option.querySelector('[data-ppm-variant-input]');
      if (radio) {
        radio.checked = true;
        var variantId = radio.value;
        var price = radio.dataset.price;
        if (variantInput && variantId) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (atcPrice && price) {
          atcPrice.textContent = formatMoney(parseInt(price, 10), moneyFormat);
        }
        goToVariantMedia(root, radio.dataset.mediaIndex);
        if (opts.updateUrl !== false) {
          updateVariantUrl(root, variantId);
        }
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (root.dataset.ppmSizePack === 'true') {
      initSizePackVariants(root, {
        selectVariantBlock: selectVariantBlock,
        findVariantOptionById: findVariantOptionById,
        getUrlVariantId: getUrlVariantId,
      });
      return;
    }

    var variantBlocks = root.querySelectorAll('[data-ppm-variant-block]');

    if (variantBlocks.length) {
      variantBlocks.forEach(function (option) {
        option.addEventListener('click', function () {
          selectVariantBlock(option);
        });
      });

      var selected =
        findVariantOptionById(root, getUrlVariantId()) ||
        root.querySelector('.ppm-variant__option--selected') ||
        variantBlocks[variantBlocks.length - 1];
      if (selected) selectVariantBlock(selected, { updateUrl: !!getUrlVariantId() });
    }
  }

  function initVideoCard(card) {
    var video = card.querySelector('video');
    var playBtn = card.querySelector('[data-ppm-video-play]');
    if (!video || !playBtn || playBtn.dataset.ppmVideoPlayBound === 'true') return;

    playBtn.dataset.ppmVideoPlayBound = 'true';
    video.controls = false;
    video.removeAttribute('controls');
    video.setAttribute('playsinline', '');
    video.playsInline = true;

    function revealControls() {
      video.controls = true;
      card.classList.add('is-ppm-video-played');
    }

    playBtn.addEventListener('click', function () {
      video.play().catch(function () {});
    });

    video.addEventListener('play', revealControls);
  }

  function destroyVideosSwiper(root) {
    if (root._ppmVideosSwiper) {
      root._ppmVideosSwiper.destroy(true, true);
      root._ppmVideosSwiper = null;
    }
  }

  function initVideosSection(root) {
    if (!root || root.dataset.ppmVideosInit === 'true') return;

    var swiperEl = root.querySelector('[data-ppm-videos-swiper]');
    if (!swiperEl) return;

    destroyVideosSwiper(root);

    root.querySelectorAll('.ppm__video-card').forEach(initVideoCard);

    swiperEl.addEventListener(
      'play',
      function (event) {
        var playing = event.target;
        if (!playing || playing.tagName !== 'VIDEO') return;

        swiperEl.querySelectorAll('video').forEach(function (video) {
          if (video !== playing && !video.paused) {
            video.pause();
          }
        });
      },
      true
    );

    if (typeof Swiper !== 'undefined' && swiperEl.querySelectorAll('.swiper-slide').length > 0) {
      root._ppmVideosSwiper = new Swiper(swiperEl, {
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: true,
        grabCursor: true,
      });
    }

    root.dataset.ppmVideosInit = 'true';
  }

  function initTestimonialSections() {
    document.querySelectorAll('[data-ppm-testimonial-section]').forEach(initTestimonial);
  }

  function initVideosSections() {
    document.querySelectorAll('[data-ppm-videos-section]').forEach(initVideosSection);
  }

  function placeFeaturedReview(section) {
    if (!section) return;
    var review = section.querySelector('.ppm__featured-review');
    var mediaCol = section.querySelector('.ppm__media-col');
    var contentCol = section.querySelector('.ppm__content-col');
    var videosBlock = section.querySelector('.ppm__videos-block');
    if (!review || !mediaCol || !contentCol) return;

    var thumbs = mediaCol.querySelector('.ppm__thumbs');
    if (window.matchMedia('(min-width: 990px)').matches) {
      if (thumbs) {
        thumbs.insertAdjacentElement('afterend', review);
      } else {
        mediaCol.appendChild(review);
      }
      return;
    }

    if (videosBlock) {
      videosBlock.insertAdjacentElement('afterend', review);
    } else {
      contentCol.appendChild(review);
    }
  }

  var placeFeaturedReviewTimer;
  function schedulePlaceFeaturedReviews() {
    clearTimeout(placeFeaturedReviewTimer);
    placeFeaturedReviewTimer = setTimeout(function () {
      document.querySelectorAll('[data-ppm-section]').forEach(placeFeaturedReview);
    }, 0);
  }

  function initProductMayPage() {
    document.querySelectorAll('[data-ppm-section]').forEach(function (section) {
      placeFeaturedReview(section);
      initSection(section);
    });
    initTestimonialSections();
    initVideosSections();
  }

  window.addEventListener('resize', schedulePlaceFeaturedReviews);

  initProductMayPage();

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ppm-section]');
    if (section) {
      placeFeaturedReview(section);
      destroyGallerySwipers(section);
      delete section.dataset.ppmInit;
      var descriptionWrap = section.querySelector('[data-ppm-description]');
      if (descriptionWrap) delete descriptionWrap.dataset.ppmDescriptionInit;
      section.querySelectorAll('.ppm-accordion').forEach(function (accordion) {
        delete accordion.dataset.ppmAccordionInit;
        delete accordion.dataset.ppmAccordionAnimating;
      });
      initSection(section);
      event.target.querySelectorAll('[data-ppm-testimonial-section]').forEach(function (el) {
        delete el.dataset.ppmTestimonialInit;
        initTestimonial(el);
      });
      event.target.querySelectorAll('[data-ppm-videos-section]').forEach(function (el) {
        destroyVideosSwiper(el);
        delete el.dataset.ppmVideosInit;
        initVideosSection(el);
      });
    }
    var testimonialSection = event.target.querySelector('[data-ppm-testimonial-section]');
    if (testimonialSection) {
      delete testimonialSection.dataset.ppmTestimonialInit;
      initTestimonial(testimonialSection);
    }
    var videosSection = event.target.querySelector('[data-ppm-videos-section]');
    if (videosSection) {
      destroyVideosSwiper(videosSection);
      delete videosSection.dataset.ppmVideosInit;
      initVideosSection(videosSection);
    }

  });
})();
